import React from 'react';
import { SoundItemRenderer } from './../menus/SoundItemRenderer';
import properties from '../../constants/Properties';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import mouseUtils from '../../components/utils/MouseUtils';

export const MediaSoundsList = React.createClass({
    getInitialState() {
        return {
            elements: []
        };
    },
    componentDidMount() {
        this.initElements();
    },
    componentWillReceiveProps: function(nextProps) {
        var currentItem;
        var nextItem;

        if (this.props.dataProvider && this.props.dataProvider[0])
            currentItem = this.props.dataProvider[0].title;

        if (nextProps.dataProvider && nextProps.dataProvider[0])
            nextItem = nextProps.dataProvider[0].title;

        if (currentItem != nextItem || this.props.accordionWidth != nextProps.accordionWidth)
            this.recreateElements();
    },
    recreateElements() {
        setTimeout(this.refreshNewContent, 50);
    },
    refreshNewContent() {
        this.initElements();
    },
    initElements() {
        let elements = [];
        let items = this.props.dataProvider;
        let i;

        if (items && items.length > 0) {
            for (i = 0; i < items.length; i++) {
                const item = items[i];
                elements.push(<SoundItemRenderer accordionWidth={this.props.accordionWidth} index={i} key={'soundsList' + item.contentItemId + '_' + Math.random()} dispatch={this.props.dispatch} value={item} isMediaSound={true}/>);
            }
        }

        this.setState({
            elements
        });
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        setTimeout(this.refreshView, 5);
    },
    refreshView() {
        this.forceUpdate();
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.elements != nextState.elements || this.props.accordionWidth != newProps.accordionWidth || this.props.dataProvider != newProps.dataProvider || this.props.height != newProps.height)
            return true;
        else
            return false;
    },
    render() {
        if (this.state == undefined || this.state.elements == undefined || this.props.dataProvider == undefined)
            return (<div/>);

        let displayState = 'none';

        if (this.props.dataProvider && this.props.dataProvider.length > 0)
            displayState = 'inline-block';

        var topPosition;
        var clipartButtonHeight = properties.CLIPART_BUTTON_HEIGHT;
        var buttonHeight = properties.STYLING_BUTTON_HEIGHT;
        var topExtraPadding = 5;
        var bottomExtraPadding = properties.MY_MEDIA_FILES_GAP;

        if (this.props.categoriesVisible)
            topPosition = clipartButtonHeight + buttonHeight + properties.MY_MEDIA_FILES_GAP + properties.EFFECTS_BUTTON_HEIGHT + properties.MY_MEDIA_FILES_GAP + topExtraPadding;
        else
            topPosition = clipartButtonHeight + buttonHeight + properties.MY_MEDIA_FILES_GAP + topExtraPadding;

        if (this.props.isAudioTab) {
            topExtraPadding = 0;
            bottomExtraPadding = 0;
            buttonHeight = properties.BROWSER_BUTTON_HEIGHT;

            if (this.props.categoriesVisible)
                topPosition = buttonHeight + properties.CATEGORY_SELECTOR_HEIGHT;
            else
                topPosition = buttonHeight + properties.MY_MEDIA_FILES_GAP + topExtraPadding;
        }

        if (this.props.showUploadButton)
            topPosition = topPosition + 50;

        const listStyle = {
            width: this.props.accordionWidth,
            height: this.props.height - topPosition - bottomExtraPadding,
            backgroundColor: 'white',
            position: 'absolute',
            top: topPosition,
            overflowX: 'hidden',
            overflowY: 'hidden',
            display: displayState
        };

        var componentProperties = {};
        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = this.props.accordionWidth;
        componentProperties.height = this.props.height - topPosition - properties.MY_MEDIA_FILES_GAP;
        componentProperties.top = 0;
        componentProperties.displayState = 'block';
        componentProperties.elements = this.state.elements;
        componentProperties.scrollHeight = (properties.SOUND_ITEM_HEIGHT + properties.SOUND_ITEMS_GAP) * this.state.elements.length;

        return (
            <div id="listWrapper" style={listStyle} onClick={this.onClick} onTouchEnd={this.onClick}>
                <ScrollableComponent componentProperties={componentProperties}/>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/MediaSoundsList.js
 **/